import React from "react"
import TitleTab from "../../../shared/components/atoms/title-tab/title-tab"

/* Images */
import step1 from "../../../assets/images/icons-steps/Póntelo.svg"
import step2 from "../../../assets/images/icons-steps/úsalos.svg"
import step3 from "../../../assets/images/icons-steps/Lávalo.svg"
import step4 from "../../../assets/images/icons-steps/Grupo 7250.svg"
import step5 from "../../../assets/images/icons-steps/Usa.svg"
import imgHowUse from "../../../assets/images/img-how-use.png"
import imgHowUse_cl from "../../../assets/images/img-how-use-cl.png"
import retiraVacia from "../../../assets/images/retirar cup.png"
import comoLavar from "../../../assets/images/Toalla-reutilizable/como-lavar.png"
import tecnologia from "../../../assets/images/Toalla-reutilizable/tecnologia.png"


import useMediaQuery from "../../../shared/utils/useMediaQuery"

import "./how-use-product.scss"

const HowUseProduct = ({ mobile , flujoType, code}) => {

  const isCup = code.includes("CUP")
  const isToallaReu = code.includes("TREU")

  const isMobile = useMediaQuery()
  const steps = isCup ? 
  [
    {
      id: 1,
      title: "1. Ponte cómoda",
      description: (
        <p className="f-description-step">
          Sentada, en cuclillas o con una pierna sobre el sanitario. Te sugerimos elegir la misma
          posición que cuando la pusiste ¡Tú decides!
        </p>
      ),
    },
    {
      id: 2,
      title: "2. Rompe el vacío",
      description: (
        <>
        <p className="f-description-step">
          Pon tus dedos sobre la base de la copa y presiona tu Nosotras® V-Cup suavemente para 
          romper el vacío. En caso de no alcanzar la base, jala ligeramente la copa del tallo 
          hasta que la logres alcanzar.  
        </p>
        <br />
        <p className="f-description-step-note">
          <b>Nota: </b>nunca jales la copa por el tallo con fuerza ya que podrías lastimarte y derramar el
          flujo. Recuerda siempre liberar el vacío para poder retirar la copa.
        </p>
        </>
      ),
    },
    {
      id: 3,
      image: step3,
      title: "3. Quita tu Nosotras® V-Cup",
      description: (
        <p className="f-description-step">
          Dobla ligeramente de lado a lado para que los bordes salgan fácilmente
          y mantenla hacia arriba para evitar derramar el flujo.
        </p>
      ),
    },
    {
      id: 4,
      image: step4,
      title: "4. Limpia tu Nosotras® V-Cup",
      description: (
        <p className="f-description-step">
          Vacía el contenido en el sanitario y enjuaga la copa con agua y jabón antes de insertarla nuevamente.
        </p>
      ),
    },
  ] : isToallaReu ? [
    {
      id: 1,
      title: "1.  Primera capa",
      description: (
        <p className="f-description-step">
          Es suave, absorbe el flujo con rapidez y aleja la humedad del cuerpo.
        </p>
      ),
    },
    {
      id: 2,
      title: "2. Capas absorbentes",
      description: (
        <p className="f-description-step">
        Dos capas que retienen el flujo y mantienen el olor controlado.  
        </p>
      ),
    },
    {
      id: 3,
      title: "3.  Última capa",
      description: (
        <p className="f-description-step">
          Es respirable y previene derrames en tu panty.
        </p>
      ),
    },
  ] :
  [
    {
      id: 1,
      image: step1,
      title: "1. Póntelo",
      description: (
        <p className="f-description-step">
          {" "}
          Usa tu{" "}
          {process.env.LOCALE === "es-BO"
            ? "ropa interior Íntima Wear"
            : process.env.LOCALE === "es-CL"
            ? "calzón"
            : "panty"}{" "}
          <b>desde el primer día</b> de tu período.
        </p>
      ),
    },
    {
      id: 2,
      image: step2,
      title: "2. Cámbialo",
      description: (
        <p className="f-description-step">
          {process.env.LOCALE === "es-CL" ? (
            <>
              Te recomendamos que después de pasadas {flujoType === 'Abundante' ? 12 : 8-10 } horas de uso, cambies
              tu calzón. Por lo que sería ideal que tengas dos para que puedas
              reemplazarlo y usar Intimawear durante todo tu periodo
            </>
          ) : (
            <>
              Después de pasadas {flujoType === 'Abundante' ? 12 : 8-10 } horas de uso, cámbialo. Si estas fuera
              de casa, mételo en su empaque especial{" "}
              <b>completamente sellado</b> y guárdalo en tu bolso sin problema.
            </>
          )}
        </p>
      ),
    },
    {
      id: 3,
      image: step3,
      title: "3. Lávalo",
      description: (
        <p className="f-description-step">
          A mano <b>con agua fría</b> y luego, para eliminar cualquier residuo,
          vuelve a lavarlo en la lavadora. ¡No uses suavizante ni blanqueador!
        </p>
      ),
    },
    {
      id: 4,
      image: step4,
      title: "4. Déjalo secar",
      description: (
        <p className="f-description-step">
          <b>Al aire libre</b> (no lo metas a la secadora). Es posible que seque
          un poco más despacio que{" "}
          {process.env.LOCALE === "es-CL"
            ? "la ropa interior normal."
            : "un panty normal."}
        </p>
      ),
    },
    {
      id: 5,
      image: step5,
      title: `5. Usa + Lava + Reusa ${
        process.env.LOCALE !== "es-CL" ? "y cuida el planeta" : ""
      }`,
      description: (
        <p className="f-description-step">
          Vuelve a usarlo cuando <b>esté completamente seco.</b> ¿Ves? ¡Es muy
          fácil!
        </p>
      ),
    },
  ]

  return (
    <section className="f-container-how-use-product">
      <div className={`f-content-wrapper${isToallaReu ? '-toalla':''}`}>
        {isCup ? <img
          src={retiraVacia}
          className="f-how-use-img"
          alt="Retirar y vaciar V-Cup"
        />:
        isToallaReu ?
        <img
          src={tecnologia}
          className="f-how-use-img"
          alt="Retirar y vaciar V-Cup"
        />:
        <img
          src={process.env.LOCALE === "es-CL" ? imgHowUse_cl : imgHowUse}
          className="f-how-use-img" style={!isCup && isMobile ? {'display': 'none'}: {}}
        />}
        <div className={`f-content-how-use`}>
          {isCup ?
            <TitleTab
              className={"f-TitleTab f-TitleTab-pink"}
              title="Retira y vacía"
            /> : isToallaReu ?
              <TitleTab
                className={"f-TitleTab f-TitleTab-pink"}
                title={"Tecnología superior"}
              /> :
              <TitleTab
                className={"f-TitleTab f-TitleTab-pink"}
                title={mobile ? "Cómo usarlos" : "Cómo usarlos en 5 pasos"}
              />
          }
          {isToallaReu ?
          <p className="f-content-how-use-description">La Toalla Reutilizable Nosotras® tiene una tecnología 
          superior que combina 3 capas para mayor comodidad y 
          protección:</p>
          :null}
          <div className="f-container-steps-how-use">
            {steps.map(step => !isCup && !isToallaReu ? (
              <div className="f-step-how" key={step.id}>
                <div className="f-step-image">
                  <img src={step.image} alt={step.title} />
                </div>
                <div className="f-container-description-step">
                  <p className="f-title-step">{step.title}</p>
                  {step.description}
                </div>
              </div>
            ):(
                <div className="f-step-how" key={step.id}>
                  <div className="f-container-description-step">
                    <p className="f-title-step">{step.title}</p>
                    {step.description}
                  </div>
                </div>))}
          </div>
        </div>
      </div>
      {isToallaReu && (
        <div className="f-content-break"></div>
      )}
      {isToallaReu && (
        <section className="f-container-how-use-product-wash">
          <div className="f-container-how-use-product-wash-container">
            <TitleTab
              className={"f-TitleTab f-TitleTab-pink f-TitleTab-margin"}
              title="¿Cómo lavar tu toalla reutilizable?"
            />
            <img
              src={comoLavar}
              className="f-container-how-use-product-wash-img"
              alt="Como lavar toalla"
            />
          </div>
        </section>
      )}
      {isToallaReu && (
        <div className="f-content-break"></div>
      )}
    </section>
  )
}

export default HowUseProduct
